export const staticPrimaryColor = '#6782f0'
export const staticPrimaryDarkenColor = '#5d7ad8'
export const themes = {
  light: {
    dark: false,
    colors: {
      'primary': staticPrimaryColor,
      'on-primary': '#fff',
      'primary-darken-1': '#675DD8',
      'secondary': '#808390',
      'on-secondary': '#fff',
      'secondary-darken-1': '#737682',
      'success': '#28C76F',
      'on-success': '#fff',
      'success-darken-1': '#24B364',
      'info': '#00BAD1',
      'on-info': '#fff',
      'info-darken-1': '#00A7BC',
      'warning': '#FF9F43',
      'on-warning': '#fff',
      'warning-darken-1': '#E68F3C',
      'error': '#FF4C51',
      'on-error': '#fff',
      'error-darken-1': '#E64449',
      'indigo': '#6e84fa',
      'on-indigo': '#fff',
      'indigo-darken-1': '#25338c',
      'purple': '#9C27B0',
      'on-purple': '#fff',
      'purple-darken-1': '#591078',
      'deep-purple': '#673AB7',
      'on-deep-purple': '#fff',
      'deep-purple-darken-1': '#512DA8',
      'teal': '#009688',
      'on-teal': '#fff',
      'teal-darken-1': '#025c52',
      'orange': '#FF9800',
      'on-orange': '#fff',
      'orange-darken-1': '#F57C00',
      'pink': '#E91E63',
      'on-pink': '#fff',
      'pink-darken-1': '#C2185B',
      'cyan': '#00BCD4',
      'on-cyan': '#fff',
      'cyan-darken-1': '#0097A7',
      'background': '#F8F7FA',
      'on-background': '#2F2B3D',
      'surface': '#fff',
      'on-surface': '#2F2B3D',
      'grey-50': '#FAFAFA',
      'grey-100': '#F5F5F5',
      'grey-200': '#EEEEEE',
      'grey-300': '#E0E0E0',
      'grey-400': '#BDBDBD',
      'grey-500': '#9E9E9E',
      'grey-600': '#757575',
      'grey-700': '#616161',
      'grey-800': '#424242',
      'grey-900': '#212121',
      'grey-light': '#FAFAFA',
      'perfect-scrollbar-thumb': '#DBDADE',
      'skin-bordered-background': '#fff',
      'skin-bordered-surface': '#fff',
      'expansion-panel-text-custom-bg': '#fafafa',
    },
    variables: {
      'code-color': '#d400ff',
      'overlay-scrim-background': '#2F2B3D',
      'tooltip-background': '#2F2B3D',
      'overlay-scrim-opacity': 0.5,
      'hover-opacity': 0.06,
      'focus-opacity': 0.1,
      'selected-opacity': 0.08,
      'activated-opacity': 0.16,
      'pressed-opacity': 0.14,
      'dragged-opacity': 0.1,
      'disabled-opacity': 0.4,
      'border-color': '#2F2B3D',
      'border-opacity': 0.12,
      'table-header-color': '#EAEAEC',
      'high-emphasis-opacity': 0.9,
      'medium-emphasis-opacity': 0.7,
      'switch-opacity': 0.2,
      'switch-disabled-track-opacity': 0.3,
      'switch-disabled-thumb-opacity': 0.4,
      'switch-checked-disabled-opacity': 0.3,
      'track-bg': '#F1F0F2',

      // Shadows
      'shadow-key-umbra-color': '#2F2B3D',
      'shadow-xs-opacity': 0.10,
      'shadow-sm-opacity': 0.12,
      'shadow-md-opacity': 0.14,
      'shadow-lg-opacity': 0.16,
      'shadow-xl-opacity': 0.18,
    },
  },
  dark: {
    dark: true,
    colors: {
      accent: '#607d8b',
      primary: '#e91e63',
      'on-primary': '#FFFFFF',
      'primary-darken-1': '#414dcc',

      secondary: '#673ab7',
      'on-secondary': '#FFFFFF',
      'secondary-darken-1': '#7E8599',

      success: '#00C48D',
      'on-success': '#FFFFFF',
      'success-darken-1': '#00A37C',

      info: '#29B6F6',
      'on-info': '#FFFFFF',
      'info-darken-1': '#2196F3',

      warning: '#FFB547',
      'on-warning': '#1E1E1E',
      'warning-darken-1': '#E69A3A',

      error: '#EF5350',
      'on-error': '#FFFFFF',
      'error-darken-1': '#D32F2F',
      'indigo': '#5C6BC0',
      'on-indigo': '#fff',
      'indigo-darken-1': '#3F51B5',
      'purple': '#AB47BC',
      'on-purple': '#fff',
      'purple-darken-1': '#9C27B0',
      'deep-purple': '#7E57C2',
      'on-deep-purple': '#fff',
      'deep-purple-darken-1': '#673AB7',
      'teal': '#26A69A',
      'on-teal': '#fff',
      'teal-darken-1': '#009688',
      'orange': '#FFA726',
      'on-orange': '#fff',
      'orange-darken-1': '#FF9800',
      'pink': '#EC407A',
      'on-pink': '#fff',
      'pink-darken-1': '#E91E63',
      'cyan': '#26C6DA',
      'on-cyan': '#fff',
      'cyan-darken-1': '#00BCD4',

      background: '#1E1F2B',
      'on-background': '#ffffff',

      surface: '#2A2C3A',
      'on-surface': '#E0E0F0',

      'grey-50': '#212230',
      'grey-100': '#2A2C3A',
      'grey-200': '#323446',
      'grey-300': '#44475C',
      'grey-400': '#5C5F78',
      'grey-500': '#707493',
      'grey-600': '#9EA3C1',
      'grey-700': '#B2B7D5',
      'grey-800': '#D0D3E8',
      'grey-900': '#ECEEFF',

      'grey-light': '#2F3045',
      'perfect-scrollbar-thumb': '#454A60',

      'skin-bordered-background': '#2A2C3A',
      'skin-bordered-surface': '#2A2C3A',
    },

    variables: {
      'code-color': '#BB86FC',
      'overlay-scrim-background': '#0E0F1B',
      'overlay-scrim-opacity': 0.6,

      'tooltip-background': '#2F3045',

      'hover-opacity': 0.06,
      'focus-opacity': 0.1,
      'selected-opacity': 0.08,
      'activated-opacity': 0.16,
      'pressed-opacity': 0.14,
      'dragged-opacity': 0.1,
      'disabled-opacity': 0.4,

      'border-color': '#3F4255',
      'border-opacity': 0.12,
      'table-header-color': '#5C5F78',

      'high-emphasis-opacity': 0.9,
      'medium-emphasis-opacity': 0.7,

      'switch-opacity': 0.4,
      'switch-disabled-track-opacity': 0.4,
      'switch-disabled-thumb-opacity': 0.8,
      'switch-checked-disabled-opacity': 0.3,

      'track-bg': '#393C52',

      // Shadows
      'shadow-key-umbra-color': '#131120',
      'shadow-xs-opacity': 0.16,
      'shadow-sm-opacity': 0.18,
      'shadow-md-opacity': 0.2,
      'shadow-lg-opacity': 0.22,
      'shadow-xl-opacity': 0.24,
    },
  },
}
export default themes
